import React, { useEffect, useState } from "react";
import LeafletMapComponent from "./LeafletMapComponent";

const LocationHeatmapPage = () => {
  const [data, setData] = useState([]);
const API_URL = process.env.REACT_APP_API_SERVER_URL;
  useEffect(() => {
    fetch(`${API_URL}/maiApi/location-heatmap`)
      .then(res => res.json())
      .then(setData)
      .catch(err => console.error("Error fetching heatmap data:", err));
  }, []);

  return (
    <div className="w-full h-screen">
      <LeafletMapComponent
        center={[32.9390527, -96.8227243]} // default center
        zoom={12}
        data={data}
        dataType="location"
      />
    </div>
  );
};

export default LocationHeatmapPage;
